import { render, staticRenderFns } from "./AwardSearch.vue?vue&type=template&id=4f6638c5&scoped=true"
import script from "./AwardSearch.vue?vue&type=script&lang=js"
export * from "./AwardSearch.vue?vue&type=script&lang=js"
import style0 from "./AwardSearch.vue?vue&type=style&index=0&id=4f6638c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6638c5",
  null
  
)

export default component.exports